(() => {
  function previewHtml(releases, options = {}) {
    const data = JSON.stringify(Array.isArray(releases) ? releases : []).replace(/</g, "\\u003c");
    const viewOptions = JSON.stringify(options && typeof options === "object" ? options : {}).replace(/</g, "\\u003c");
    return `<!doctype html>
<html lang="en">
<head>
<meta charset="utf-8">
<meta name="viewport" content="width=device-width,initial-scale=1,viewport-fit=cover">
<title>KoB Release Timeline</title>
<style>
:root{--ink:#56617c;--muted:#8b94a8;--line:#d9dfeb;--paper:#f7f8fb;--dark:#11141b}
*{box-sizing:border-box}
html,body{margin:0;min-height:100%;font-family:Inter,"Helvetica Neue",Arial,sans-serif;letter-spacing:0}
body{background:var(--dark);color:#f7f8fb;overflow:hidden}
.topbar{position:fixed;inset:0 0 auto;z-index:30;display:flex;justify-content:space-between;align-items:center;padding:22px 28px;color:rgba(247,248,251,.58);font-size:11px;letter-spacing:.16em;text-transform:uppercase;transition:color .45s}
.topbar button{border:0;border-bottom:1px solid currentColor;padding:0 0 3px;background:transparent;color:inherit;font:inherit;letter-spacing:inherit;text-transform:inherit;cursor:pointer}
.wave{height:100vh;position:relative;overflow:hidden;background:radial-gradient(circle at 50% 52%,#171b24 0,#11141b 58%,#0e1117 100%);touch-action:none}
.wave-stage{height:100%;display:grid;grid-template-columns:minmax(0,1fr) minmax(220px,16vw) minmax(0,1fr);align-items:center;gap:7vw;padding:40px 4vw}
.wave-column{position:relative;height:82vh;min-width:0;overflow:visible}
.wave-word{position:absolute;top:50%;left:0;width:max-content;max-width:38vw;border:0;padding:0;background:transparent;color:rgba(247,248,251,.16);font-family:Georgia,"Times New Roman",serif;font-size:clamp(34px,5.2vw,82px);line-height:.86;letter-spacing:0;text-align:left;opacity:.66;transition:color .25s ease,opacity .25s ease;will-change:transform,color,opacity}
.wave-column--right .wave-word{left:auto;right:0;text-align:right}
.wave-word.is-active{color:#f7f8fb;opacity:1;z-index:2}
.wave-word.is-near{color:rgba(247,248,251,.36);opacity:.9}
.wave-media{position:relative;z-index:5;width:100%;aspect-ratio:4/3;display:grid;place-items:center;background:rgba(255,255,255,.045);overflow:hidden;box-shadow:0 28px 84px rgba(0,0,0,.28);transition:background .3s,box-shadow .3s}
.wave-media img{position:absolute;inset:0;display:block;width:100%;height:100%;object-fit:cover;opacity:0;transform:scale(1.012);transition:opacity .3s ease,transform .55s cubic-bezier(.2,.8,.2,1)}
.wave-media img.is-visible{opacity:1;transform:scale(1)}
.wave-media.is-logo{background:rgba(255,255,255,.94);box-shadow:0 28px 84px rgba(0,0,0,.22)}
.wave-media.is-logo img{object-fit:contain;padding:18%}
.wave-media.is-locked{background:transparent;box-shadow:none;overflow:visible}
.wave-media.is-locked::before{content:"?";position:relative;z-index:2;font-family:Georgia,"Times New Roman",serif;font-size:clamp(94px,11vw,176px);font-weight:400;line-height:1;color:rgba(247,248,251,.68);text-shadow:0 18px 52px rgba(0,0,0,.48)}
.wave-media.is-locked::after{content:"";position:absolute;inset:9%;border:1px solid rgba(247,248,251,.12);border-radius:50%;transform:scale(.86);opacity:.8}
.transition{position:fixed;inset:0;z-index:60;display:grid;place-items:center;background:var(--paper);color:var(--ink);opacity:0;pointer-events:none;transition:opacity .42s}
.transition.is-active{opacity:1}
.transition strong{font-family:Georgia,"Times New Roman",serif;font-size:clamp(52px,8vw,124px);line-height:.84}
.timeline{display:none;min-height:100vh;padding:clamp(72px,8vw,128px) clamp(20px,6vw,100px) 130px;background:var(--paper);color:var(--ink)}
body.is-index{overflow:auto;background:var(--paper)}
body.is-index .topbar{color:rgba(86,97,124,.62)}
body.is-index .topbar button{display:none}
body.is-index .wave{display:none}
body.is-index .timeline{display:block}
.timeline-head{margin-bottom:clamp(48px,6vw,84px)}
.timeline-head h1{margin:0;font-family:Georgia,"Times New Roman",serif;font-size:clamp(54px,8vw,126px);line-height:.84}
.timeline-list{max-width:1480px;margin:0 auto}
.timeline-row{position:relative;display:grid;grid-template-columns:142px 26px minmax(160px,230px) minmax(0,1fr);gap:clamp(18px,3vw,38px);align-items:center;min-height:178px;padding:26px 0;border-top:1px solid var(--line);opacity:0;transform:translateY(34px);transition:opacity .72s ease,transform .86s cubic-bezier(.2,.8,.2,1)}
.timeline-row.is-visible{opacity:1;transform:translateY(0)}
.timeline-row:last-child{border-bottom:1px solid var(--line)}
.timeline-date{text-align:right;font-family:Georgia,"Times New Roman",serif;font-size:clamp(20px,1.65vw,27px);line-height:1.05;color:#707c96}
.timeline-line{position:relative;align-self:stretch}
.timeline-line::before{content:"";position:absolute;left:50%;top:-27px;bottom:-27px;width:1px;background:var(--line)}
.timeline-line::after{content:"";position:absolute;left:50%;top:50%;width:11px;height:11px;border-radius:50%;background:var(--ink);transform:translate(-50%,-50%);box-shadow:0 0 0 8px var(--paper)}
.timeline-media{height:132px;display:grid;place-items:center;border:1px solid rgba(86,97,124,.14);background:#eef2f8;overflow:hidden}
.timeline-media img{display:block;width:100%;height:100%;object-fit:cover}
.timeline-media.is-logo img{object-fit:contain;padding:24px}
.timeline-media.is-locked::before{content:"?";font-family:Georgia,"Times New Roman",serif;font-size:74px;line-height:1;color:rgba(86,97,124,.48)}
.tags{display:flex;flex-wrap:wrap;gap:7px}
.tags span{display:inline-flex;align-items:center;min-height:27px;padding:0 10px;border:1px solid var(--line);font-size:10px;letter-spacing:.14em;text-transform:uppercase}
.tags .scale{background:var(--ink);border-color:var(--ink);color:var(--paper)}
.timeline-copy h2{margin:13px 0 7px;font-family:Georgia,"Times New Roman",serif;font-size:clamp(28px,3vw,48px);line-height:1.02;overflow-wrap:anywhere}
.timeline-copy small{display:block;margin-bottom:8px;color:#9aa3b7;font-size:11px;letter-spacing:.15em;text-transform:uppercase}
.timeline-copy p{margin:0;color:var(--muted);font-size:14px}
.timeline-copy em{font-style:normal;color:#c0c7d4;margin:0 8px}
@media(max-width:760px){
  .topbar{padding:18px}
  .wave-stage{grid-template-columns:minmax(0,1fr) minmax(132px,36vw) minmax(0,1fr);gap:4vw;padding:0 10px}
  .wave-column{height:86vh}
  .wave-word{max-width:43vw;font-size:clamp(20px,6vw,28px);line-height:.82}
  .wave-media{width:100%}
  .wave-media.is-locked::before{font-size:96px}
  .timeline{padding:62px 18px 90px}
  .timeline-head h1{font-size:58px}
  .timeline-row{grid-template-columns:1fr;gap:13px;padding:28px 0}
  .timeline-date{text-align:left;font-size:20px}
  .timeline-line{display:none}
  .timeline-media{height:auto;aspect-ratio:16/9}
  .timeline-copy h2{font-size:28px}
}
@media(prefers-reduced-motion:reduce){.wave-word,.wave-media img,.timeline-row,.transition{transition-duration:.01ms!important}}
</style>
</head>
<body>
<header class="topbar"><span>KoB Release Timeline</span><button id="indexButton" type="button">Release Index</button></header>
<main id="wave" class="wave"><div class="wave-stage"><div id="left" class="wave-column"></div><div id="media" class="wave-media"><img id="mediaImage" alt=""></div><div id="right" class="wave-column wave-column--right"></div></div></main>
<div id="transition" class="transition"><strong>Release<br>Index</strong></div>
<section id="timeline" class="timeline"><header class="timeline-head"><h1>Release<br>Index</h1></header><div id="timelineList" class="timeline-list"></div></section>
<script>
const releases=${data};
const viewOptions=${viewOptions};
const left=document.getElementById('left');
const right=document.getElementById('right');
const media=document.getElementById('media');
const mediaImage=document.getElementById('mediaImage');
const timelineList=document.getElementById('timelineList');
const transition=document.getElementById('transition');
const maxIndex=Math.max(0,releases.length-1);
const imageCache=new Map();
let position=Math.max(0,Math.min(maxIndex,Number(viewOptions.initialIndex)||0));
let active=-1;
let mediaToken=0;
let wheelActive=false;
let wheelTimer=0;
let indexLocked=false;
let touchTracking=false;
let touchAxis='';
let touchStartX=0;
let touchStartY=0;
let touchStartPosition=0;
let touchLastY=0;
let touchLastAt=0;
let touchVelocityY=0;
let touchFrame=0;
let touchPendingPosition=0;
let snapFrame=0;
let revealObserver=null;

function esc(value){return String(value==null?'':value).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;')}
function clamp(value,min,max){return Math.max(min,Math.min(max,value))}
function titleFor(item){return item.title||item.brand||item.maker||'Confidential Release'}
function stageLabel(stage){return stage==='full'?'Released':stage}
function preloadImage(source){
  if(!source)return Promise.resolve(null);
  if(imageCache.has(source))return imageCache.get(source);
  const promise=new Promise(function(resolve){
    const image=new Image();
    image.decoding='async';
    image.onload=function(){
      const decoded=typeof image.decode==='function'?image.decode().catch(function(){}):Promise.resolve();
      decoded.then(function(){resolve(image)});
    };
    image.onerror=function(){resolve(null)};
    image.src=source;
  });
  imageCache.set(source,promise);
  return promise;
}
function preloadWaveImages(){
  Array.from(new Set(releases.map(function(item){return item.wave_image_url}).filter(Boolean))).forEach(preloadImage);
}
function build(){
  if(!releases.length){
    left.innerHTML='<div class="wave-word is-active">NO DRAFTS</div>';
    right.innerHTML='<div class="wave-word is-active">TIMELINE</div>';
    media.className='wave-media is-locked';
    return;
  }
  left.innerHTML=releases.map(function(item,index){return '<button class="wave-word" data-index="'+index+'">'+esc(item.wave_left_keyword)+'</button>'}).join('');
  right.innerHTML=releases.map(function(item,index){return '<button class="wave-word" data-index="'+index+'">'+esc(item.wave_right_keyword)+'</button>'}).join('');
  timelineList.innerHTML=releases.map(function(item){
    const image=item.timeline_image_url?'<img loading="lazy" src="'+esc(item.timeline_image_url)+'" alt="">':'';
    const mediaClass=item.image_kind==='logo'?' is-logo':item.image_kind==='locked'?' is-locked':'';
    const scale=item.scale?'<span class="scale">'+esc(item.scale)+'</span>':'';
    const code=item.product_code?'<small>'+esc(item.product_code)+'</small>':'';
    const names=[item.maker,item.brand].filter(Boolean).map(esc).join(' <em>/</em> ');
    return '<article class="timeline-row"><div class="timeline-date">'+esc(item.release_window)+'</div><div class="timeline-line"></div><div class="timeline-media'+mediaClass+'">'+image+'</div><div class="timeline-copy"><div class="tags"><span>'+esc(stageLabel(item.stage))+'</span>'+scale+'</div><h2>'+esc(titleFor(item))+'</h2>'+code+'<p>'+names+'</p></div></article>';
  }).join('');
  document.querySelectorAll('.wave-word').forEach(function(button){button.addEventListener('click',function(){animateTo(Number(button.dataset.index),300)})});
  preloadWaveImages();
  renderPosition(position,true);
}
function updateMedia(index,force){
  if(!force&&index===active)return;
  active=index;
  const item=releases[active];
  const token=++mediaToken;
  mediaImage.classList.remove('is-visible');
  if(!item||item.image_kind==='locked'||!item.wave_image_url){
    media.className='wave-media is-locked';
    mediaImage.removeAttribute('src');
    return;
  }
  media.className='wave-media';
  preloadImage(item.wave_image_url).then(function(image){
    if(token!==mediaToken)return;
    if(!image){media.className='wave-media is-locked';mediaImage.removeAttribute('src');return}
    media.className='wave-media'+(item.image_kind==='logo'?' is-logo':'');
    mediaImage.src=item.wave_image_url;
    requestAnimationFrame(function(){if(token===mediaToken)mediaImage.classList.add('is-visible')});
  });
}
function renderPosition(next,force){
  position=clamp(next,0,maxIndex);
  const focus=clamp(Math.round(position),0,maxIndex);
  const mobile=innerWidth<761;
  const spacing=mobile?54:88;
  const amplitude=mobile?18:68;
  document.querySelectorAll('.wave-word').forEach(function(word){
    const distance=Number(word.dataset.index)-position;
    word.classList.toggle('is-active',Math.abs(distance)<.42);
    word.classList.toggle('is-near',Math.abs(distance)>=.42&&Math.abs(distance)<1.35);
    const x=Math.sin(distance*.84)*amplitude;
    const y=distance*spacing;
    word.style.transform='translate3d('+x+'px,'+y+'px,0) translateY(-50%)';
  });
  updateMedia(focus,force);
}
function animateTo(target,duration){
  if(snapFrame)cancelAnimationFrame(snapFrame);
  const from=position;
  const delta=clamp(target,0,maxIndex)-from;
  const started=performance.now();
  function frame(now){
    const progress=clamp((now-started)/(duration||240),0,1);
    const eased=1-Math.pow(1-progress,3);
    renderPosition(from+delta*eased,false);
    if(progress<1)snapFrame=requestAnimationFrame(frame);
    else snapFrame=0;
  }
  snapFrame=requestAnimationFrame(frame);
}
function activateTimelineReveal(){
  const rows=Array.from(document.querySelectorAll('.timeline-row'));
  if(!('IntersectionObserver' in window)){rows.forEach(function(row){row.classList.add('is-visible')});return}
  if(revealObserver)revealObserver.disconnect();
  revealObserver=new IntersectionObserver(function(entries){
    entries.forEach(function(entry){if(entry.isIntersecting){entry.target.classList.add('is-visible');revealObserver.unobserve(entry.target)}});
  },{threshold:.14,rootMargin:'0px 0px -10% 0px'});
  rows.forEach(function(row,index){
    row.style.transitionDelay=Math.min(index,2)*70+'ms';
    const rect=row.getBoundingClientRect();
    if(rect.top<innerHeight*.92&&rect.bottom>0)row.classList.add('is-visible');
    else revealObserver.observe(row);
  });
}
function enterIndex(){
  if(indexLocked)return;
  indexLocked=true;
  transition.classList.add('is-active');
  setTimeout(function(){
    document.body.classList.add('is-index');
    scrollTo(0,0);
    requestAnimationFrame(activateTimelineReveal);
  },430);
  setTimeout(function(){transition.classList.remove('is-active')},820);
}
function step(direction){
  if(indexLocked)return;
  const current=Math.round(position);
  if(direction>0&&current>=maxIndex){enterIndex();return}
  animateTo(current+direction,280);
}
addEventListener('wheel',function(event){
  if(indexLocked)return;
  event.preventDefault();
  if(Math.abs(event.deltaY)<8)return;
  clearTimeout(wheelTimer);
  if(!wheelActive){wheelActive=true;step(event.deltaY>0?1:-1)}
  wheelTimer=setTimeout(function(){wheelActive=false},230);
},{passive:false});
addEventListener('touchstart',function(event){
  if(indexLocked||event.touches.length!==1)return;
  if(snapFrame){cancelAnimationFrame(snapFrame);snapFrame=0}
  const touch=event.touches[0];
  touchTracking=true;
  touchAxis='';
  touchStartX=touch.clientX;
  touchStartY=touch.clientY;
  touchStartPosition=position;
  touchLastY=touch.clientY;
  touchLastAt=performance.now();
  touchVelocityY=0;
},{passive:true,capture:true});
addEventListener('touchmove',function(event){
  if(!touchTracking||indexLocked||event.touches.length!==1)return;
  const touch=event.touches[0];
  const dx=touch.clientX-touchStartX;
  const dy=touch.clientY-touchStartY;
  if(!touchAxis&&Math.max(Math.abs(dx),Math.abs(dy))>=9)touchAxis=Math.abs(dy)>Math.abs(dx)*1.1?'vertical':'horizontal';
  if(touchAxis!=='vertical')return;
  event.preventDefault();
  const now=performance.now();
  const elapsed=Math.max(1,now-touchLastAt);
  const instant=(touch.clientY-touchLastY)/elapsed;
  touchVelocityY=touchVelocityY*.62+instant*.38;
  touchLastY=touch.clientY;
  touchLastAt=now;
  const raw=touchStartPosition-dy/62;
  if(raw>=maxIndex+.72){touchTracking=false;enterIndex();return}
  touchPendingPosition=clamp(raw,0,maxIndex);
  if(!touchFrame)touchFrame=requestAnimationFrame(function(){touchFrame=0;renderPosition(touchPendingPosition,false)});
},{passive:false,capture:true});
addEventListener('touchend',function(){
  if(!touchTracking||indexLocked)return;
  touchTracking=false;
  if(touchFrame){cancelAnimationFrame(touchFrame);touchFrame=0;renderPosition(touchPendingPosition,false)}
  if(touchAxis!=='vertical')return;
  const inertia=clamp((-touchVelocityY/62)*70,-.55,.55);
  animateTo(Math.round(clamp(position+inertia,0,maxIndex)),220);
},{passive:true});
addEventListener('touchcancel',function(){touchTracking=false;touchAxis='';if(touchFrame){cancelAnimationFrame(touchFrame);touchFrame=0}},{passive:true});
document.getElementById('indexButton').addEventListener('click',enterIndex);
addEventListener('resize',function(){renderPosition(position,true)},{passive:true});
build();
<\/script>
</body>
</html>`;
  }

  function open(releases) {
    const previewWindow = window.open("", "_blank");
    if (!previewWindow) return false;
    previewWindow.opener = null;
    previewWindow.document.open();
    previewWindow.document.write(previewHtml(releases));
    previewWindow.document.close();
    return true;
  }

  const view = { html: previewHtml, open };
  window.KoBReleaseTimelineView = view;
  window.KoBTimelineDraftPreview = view;
})();
